let Optimization = {
    OPTIMIZATION_START: 'OPTIMIZATION_START',
    OPTIMIZATION_TERMINATE: 'OPTIMIZATION_TERMINATE',
};

export default Optimization;
